import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { PackageIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { useTransferOrder } from '@/api/rpc/hooks/inventory-management/useTransferOrders';

interface TransferOrderInlineProps {
  entityType: SystemEntity; // required by registry; type is IM_TRANSFER_ORDER
  entityId: string;
  className?: string;
}

export function TransferOrderInline({
  entityId,
  className,
}: TransferOrderInlineProps) {
  const { transferOrder, isLoading } = useTransferOrder(entityId);

  const transferNumber = isLoading
    ? 'Loading...'
    : (transferOrder?.transferNumber ??
      transferOrder?.internalId?.toString() ??
      'Unknown');

  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <div className="inline-block max-w-full">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer max-w-full', className)}
          >
            <PackageIcon className="size-3 shrink-0" />
            <span className="truncate">
              <span className="text-muted-foreground font-mono">TO</span>{' '}
              {transferNumber}
            </span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.IM_TRANSFER_ORDER}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
